import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const currentDate = '۱۴۰۴/۱۱/۱۴';//new Date().toLocaleDateString('fa-IR');
  const appName = "اتویاد";
  const contactEmail = "support@autoyad.ir";
  const contactAddress = "آدرس شرکت شما";

  const handlePrint = () => {
    window.print();
  };

  const handleGoBack = () => {
    navigate(-1); // بازگشت به صفحه قبلی
  };

  return (
    <div className={styles.page}>
      <Helmet>
        <title>سیاست حفظ حریم خصوصی - {appName}</title>
        <meta name="description" content="سیاست حفظ حریم خصوصی اپلیکیشن ما" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Helmet>

      {/* دکمه برگشت */}
      <button 
        onClick={handleGoBack}
        className={styles.backButton}
        aria-label="بازگشت"
      >
        <i className={`bi bi-arrow-right ${styles.backIcon}`}></i>
      </button>

      {/* هشدار ثبت‌نام */}
      <div className={styles.registrationAlert}>
        <i className={`bi bi-shield-check ${styles.alertIcon}`}></i>
        <div className="container">
          <div className={styles.alertContent}>
            <h5 className={styles.alertTitle}>ثبت‌نام در {appName}</h5>
            <p className={styles.alertText}>
              برای استفاده از خدمات ما نیاز به ثبت‌نام و تأیید شماره تلفن همراه دارید.
            </p>
            <div className="row align-items-center">
              <div className="col-7">
                <Link to="/register" className={styles.alertLink}>
                  <i className="bi bi-arrow-left"></i>
                  صفحه ثبت‌نام
                </Link>
              </div>
              <div className="col-5 text-left">
                <Link to="/register" className={`btn ${styles.registrationBtn}`}>
                  <i className="bi bi-person-plus"></i>
                  ثبت‌نام
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* هدر صفحه */}
      <div className={styles.header}>
        <div className="container">
          <h1 className={styles.title}>سیاست حفظ حریم خصوصی</h1>
          <div className={styles.badgeContainer}>
            <span className={styles.badge}>نسخه: ۱.۰</span>
            <span className={styles.badge}>آخرین بروزرسانی: {currentDate}</span>
          </div>
        </div>
      </div>

      {/* جومبترون ثبت‌نام */}
      <div className="container">
        <div className={styles.jumbotron}>
          <h2 className={styles.jumbotronTitle}>آماده استفاده از {appName} هستید؟</h2>
          <p className={styles.jumbotronSubtitle}>
            برای دسترسی به تمامی امکانات و خدمات ما، نیاز به ثبت‌نام و تأیید شماره تلفن همراه دارید.
            این فرآیند تنها ۲ دقیقه زمان می‌برد.
          </p>
          
          <ul className={styles.featureList}>
            <li className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <i className="bi bi-shield-check"></i>
              </div>
              <span className={styles.featureText}>امنیت بالا با احراز هویت دو مرحله‌ای</span>
            </li>
            <li className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <i className="bi bi-lightning"></i>
              </div>
              <span className={styles.featureText}>ثبت‌نام سریع در کمتر از ۲ دقیقه</span>
            </li>
            <li className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <i className="bi bi-phone"></i>
              </div>
              <span className={styles.featureText}>تأیید با کد ارسالی به موبایل</span>
            </li>
          </ul>

          <div className={styles.ctaButtons}>
            <Link to="/register" className={styles.ctaButton}>
              <i className="bi bi-person-plus"></i>
              ثبت‌نام سریع
            </Link>
            <Link to="/login" className={styles.loginButton}>
              <i className="bi bi-box-arrow-in-right"></i>
              ورود کاربران
            </Link>
          </div>
        </div>
      </div>

      {/* محتوای اصلی */}
      <div className={styles.contentWrapper}>
        
        {/* بخش ۱: اطلاعات جمع‌آوری شده */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <span className={styles.sectionNumber}>۱</span>
            اطلاعاتی که جمع‌آوری می‌کنیم
          </h3>
          <div className={styles.sectionContent}>
            <p>
              در فرآیند ثبت‌نام یا استفاده از برخی قابلیت‌های اپلیکیشن، 
              از شما <strong>شماره تلفن همراه</strong> درخواست می‌شود. 
              این اطلاعات به‌طور مستقیم و با اطلاع و رضایت شما دریافت می‌گردد.
            </p>
            <div className={styles.highlight}>
              <strong>نکته مهم:</strong> شما می‌توانید با مراجعه به 
              <Link to="/register" className={`mx-1 ${styles.internalLink}`}>
                صفحه ثبت‌نام
              </Link>
              و تکمیل فرم، به راحتی در اپلیکیشن ما عضو شوید.
            </div>
          </div>
        </div>

        {/* بخش ۲: دلایل جمع‌آوری */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <span className={styles.sectionNumber}>۲</span>
            چرا شماره تلفن همراه شما را نیاز داریم؟
          </h3>
          <div className={styles.sectionContent}>
            <p>شماره تلفن همراه شما ممکن است برای اهداف زیر استفاده شود:</p>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.tableHeader}>هدف</th>
                  <th className={styles.tableHeader}>توضیحات</th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>
                    <i className="bi bi-shield-check text-success me-1"></i>
                    احراز هویت
                  </td>
                  <td className={styles.tableCell}>ایجاد و محافظت از حساب کاربری شما</td>
                </tr>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>
                    <i className="bi bi-chat-text text-primary me-1"></i>
                    ارسال کد
                  </td>
                  <td className={styles.tableCell}>برای تأیید درخواست‌های مهم</td>
                </tr>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>
                    <i className="bi bi-bell text-warning me-1"></i>
                    اطلاع‌رسانی
                  </td>
                  <td className={styles.tableCell}>ارسال اعلان‌های ضروری</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* بخش ۳: حفاظت از اطلاعات */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <span className={styles.sectionNumber}>۳</span>
            نحوه حفاظت از اطلاعات شما
          </h3>
          <div className={styles.sectionContent}>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                استفاده از پروتکل‌های امنیتی استاندارد
              </li>
              <li className="mb-2">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                ذخیره در سرورهای امن با دسترسی محدود
              </li>
              <li className="mb-2 fw-bold">
                <i className="bi bi-shield-exclamation text-warning me-2"></i>
                عدم اشتراک‌گذاری بدون اجازه شما
              </li>
            </ul>
            <div className={styles.highlight}>
              <strong>تعهد ما:</strong> ما شماره تلفن شما را بدون اجازه صریح شما 
              به اشتراک نمی‌گذاریم، نمی‌فروشیم و در اختیار اشخاص ثالث برای اهداف تبلیغاتی قرار نمی‌دهیم.
            </div>
          </div>
        </div>

        {/* بخش ۴: اشتراک‌گذاری اطلاعات */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <span className={styles.sectionNumber}>۴</span>
            اشتراک‌گذاری اطلاعات با اشخاص ثالث
          </h3>
          <div className={styles.sectionContent}>
            <p>شماره تلفن شما تنها در موارد زیر ممکن است افشا شود:</p>
            <ul className="list-unstyled">
              <li className="mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-journal-check text-danger me-2 mt-1"></i>
                  <div>
                    <strong>با دستور قانونی:</strong>
                    <p className="mb-0 text-muted">در صورت درخواست مراجع قضایی یا قانونی ذی‌صلاح.</p>
                  </div>
                </div>
              </li>
              <li className="mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-hand-thumbs-up text-success me-2 mt-1"></i>
                  <div>
                    <strong>با رضایت شما:</strong>
                    <p className="mb-0 text-muted">در صورت موافقت صریح شما برای اشتراک‌گذاری با یک شخص ثالث خاص.</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <i className="bi bi-gear text-primary me-2 mt-1"></i>
                  <div>
                    <strong>ارائه‌دهندگان خدمات:</strong>
                    <p className="mb-0 text-muted">
                      به شرکت‌های معتمد و واسطه (مانند سرویس‌دهندگان پیامک) که برای عملکرد اپلیکیشن به آن‌ها نیاز داریم.
                      این شرکت‌ها متعهد به حفظ محرمانگی اطلاعات هستند.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* بخش ۵: حقوق شما */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <span className={styles.sectionNumber}>۵</span>
            حقوق شما
          </h3>
          <div className={styles.sectionContent}>
            <p>شما این حق را دارید که:</p>
            <div className="row g-3">
              <div className="col-12 col-md-4">
                <div className={`p-3 rounded ${styles.featureItem}`}>
                  <i className="bi bi-question-circle fs-4 text-info"></i>
                  <span className="ms-2">در مورد اطلاعات جمع‌آوری‌شده سؤال کنید</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className={`p-3 rounded ${styles.featureItem}`}>
                  <i className="bi bi-trash fs-4 text-danger"></i>
                  <span className="ms-2">درخواست حذف یا اصلاح اطلاعات نادرست دهید</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className={`p-3 rounded ${styles.featureItem}`}>
                  <i className="bi bi-gear fs-4 text-primary"></i>
                  <span className="ms-2">از دریافت پیامک‌های اطلاع‌رسانی انصراف دهید</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* بخش ۶: تغییرات */}
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <span className={styles.sectionNumber}>۶</span>
            تغییرات در سیاست حفظ حریم خصوصی
          </h3>
          <div className={styles.sectionContent}>
            <div className="alert alert-secondary">
              <div className="d-flex">
                <i className="bi bi-exclamation-triangle fs-4 me-3"></i>
                <div>
                  <p className="mb-0">
                    ما ممکن است این سیاست را به مرور زمان به‌روز کنیم. تغییرات عمده در این صفحه 
                    و از طریق اعلان درون‌برنامه‌ای به شما اطلاع‌رسانی خواهند شد. 
                    ادامه استفاده از اپلیکیشن پس از اعمال تغییرات به معنای پذیرش نسخه جدید سیاست است.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* بخش ۷: تماس با ما */}
        <div className={`${styles.section} ${styles.contactSection}`}>
          <h3 className={styles.sectionTitle}>
            <span className={styles.sectionNumber}>۷</span>
            تماس با ما
          </h3>
          <p className={styles.sectionContent}>
            اگر سؤالی درباره این سیاست یا نحوه مدیریت اطلاعات خود دارید، با ما در ارتباط باشید:
          </p>
          <div className={styles.contactGrid}>
            <div className={styles.contactCard}>
              <i className={`bi bi-envelope ${styles.contactIcon}`}></i>
              <h5 className={styles.contactTitle}>ایمیل</h5>
              <a href={`mailto:${contactEmail}`} className={styles.contactLink}>
                {contactEmail}
              </a>
            </div>
            {/* <div className={styles.contactCard}>
              <i className={`bi bi-geo-alt ${styles.contactIcon}`}></i>
              <h5 className={styles.contactTitle}>آدرس</h5>
              <p className="text-muted mb-0">{contactAddress}</p>
            </div> */}
          </div>
          
          {/* لینک ثبت‌نام مجدد */}
          <div className="mt-4 text-center">
            <p className="mb-3">هنوز در {appName} عضو نشده‌اید؟</p>
            <Link to="/register" className={`btn btn-success ${styles.ctaButton}`}>
              <i className="bi bi-person-plus me-2"></i>
              عضویت رایگان
            </Link>
          </div>
        </div>

        {/* فوتر */}
        <div className={styles.footer}>
          <p className={styles.footerText}>
            <i className="bi bi-clock-history me-1"></i>
            این صفحه آخرین بار در تاریخ {currentDate} به‌روزرسانی شده است.
          </p>
          <button onClick={handlePrint} className={styles.printButton}>
            <i className="bi bi-printer"></i>
            چاپ صفحه
          </button>
          <div className={styles.footerLinks}>
            <Link to="/register" className={styles.footerLink}>
              <i className="bi bi-person-plus me-1"></i>
              ثبت‌نام
            </Link>
            <Link to="/" className={styles.footerLink}>
              <i className="bi bi-house me-1"></i>
              صفحه اصلی
            </Link>
            <button onClick={handleGoBack} className={styles.footerLink}>
              <i className="bi bi-arrow-right me-1"></i>
              بازگشت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;